const shopify = "/fly-assets/logos/shopify.svg";
const woocommerce = "/fly-assets/logos/woocommerce.svg";
const quickbooks = "/fly-assets/logos/quickbooks.svg";

export const supportedConnectorMap = {
  Shopify: shopify,
  Shopify2: shopify,
  Magento: "/fly-assets/logos/magento.svg",
  WooCommerce: woocommerce,
  WooCommerce2: woocommerce,
  Stripe: "/fly-assets/logos/stripe.svg",
  eBay: "/fly-assets/logos/ebay.svg",
  "Google Analytics": "/fly-assets/logos/ga.svg",
  "Google Ads": "/fly-assets/logos/adwords.svg",
  "Facebook Ads": "/fly-assets/logos/facebook.svg",
  "Bing Ads": "/fly-assets/logos/bing.svg",
  "TikTok Ads": "/fly-assets/logos/tiktok.svg",
  Amazon: "/fly-assets/logos/amazon.svg",
  BigCommerce: "/fly-assets/logos/bigcommerce.svg",
  "Shopware 5": "/fly-assets/logos/shopware5.svg",
  PrestaShop: "/fly-assets/logos/prestashop.png",
  "Oracle NetSuite": "/fly-assets/logos/netsuite.svg",
  Xero: "/fly-assets/logos/xero.svg",
  QuickBooks: quickbooks,
  "QuickBooks Online": quickbooks,
};

export const sizeMap = {
  small: {
    full: 74,
    reduced: 60,
  },
  standard: {
    full: 84,
    reduced: 60,
  },
  large: {
    full: 96,
    reduced: 72,
  },
};
